import {
    BrowserRouter as Router,
    Switch,
    Redirect,
    Route,
} from "react-router-dom";
import { HomeScreen } from '../screens/HomeScreen';
import ScrollToTop from "../components/ScrollToTop";

export const AppRouter = () => {

    // console.warn = function () { };
    // console.error = function () { };

    return (

        <Router>

            <div className='router-content'>

                <ScrollToTop />

                <Switch>

                    <Route
                        exact
                        path='/'
                        component={HomeScreen}
                    />

                    <Redirect to='/' />

                </Switch>

            </div>

        </Router>

    )
}
